module.exports = __webpack_public_path__ + "media/guac.90afccc5.mp4";